/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import { BridgePacket, PUNK } from "../../BridgePacket";
import { DeviceUID } from "../../Devices.gen";
import { ErrorCode } from "../../Enumerations.gen";
import { PhidgetError } from "../../PhidgetError";
import { LocalChannel } from "../LocalChannel";
import { PhidgetUSBDevice, PhidgetUSBDeviceData } from "../PhidgetUSBDevice";
import { USBConnectionBase } from "../USBConnection";

export class DataAdapterDevice extends PhidgetUSBDevice {

	data: {
		inputState: number[]
	};

	constructor(conn: USBConnectionBase, data: PhidgetUSBDeviceData, usbDev: USBDevice) {
		super(conn, data, usbDev);

		// Ensure that we actually support this device
		switch (this.devDef.uid) {

			/*START_UNRELEASED*/
			// Makes sure unreleased device code isn't in the release library
			case DeviceUID._ADP1001_USB:
			case DeviceUID._ADP_RS485_422_USB:
			case DeviceUID._ADP_SERIAL_USB:
				break;
			/*END_UNRELEASED*/

			default:
				throw new PhidgetError(ErrorCode.UNSUPPORTED);
		}

		this.data = {
			inputState: new Array(this.numInputs).fill(PUNK.BOOL)
		};
	}

	// Define getters based on devices.h Attr structs in C library
	get numDataAdapters() { return this.devDef.cn[0]; }
	get numInputs() { return this.devDef.cn[1]; }
	get numOutputs() { return this.devDef.cn[2]; }

	// eslint-disable-next-line require-await
	async initAfterOpen() {
		switch (this.devDef.uid) {
			case DeviceUID._ADP1001_USB:
			case DeviceUID._ADP_RS485_422_USB:
			case DeviceUID._ADP_SERIAL_USB:
				throw new PhidgetError(ErrorCode.UNSUPPORTED, "This Phidget is not yet supported via direct USB connection in JavaScript.");
		}
	}
	dataInput(_buffer: DataView) { }
	async bridgeInput(_ch: LocalChannel, _arg1: BridgePacket) { }
}